<template>
    <PublicTemplate>




        <div class="contact__ContactPage-sc-6y2oza-0 jsJJkA">
            <div class="animated fadeInUp" style="animation-duration: 1s;">
                <section class="PageHero__HeroStyle-bmq1vi-0 gLYwgj white">
                    <div class="container" style="padding-top: 100px;">
                        <div class="animated fadeInUp" style="animation-duration: 1s;">
                            <h4 class="section_subtitle">Hỗ trợ</h4>
                            <h1 class="section_title">Liên hệ</h1>
                            <p class="content_center section_description" style="padding-bottom: 70px;">CMECH là nhà
                                cung cấp phụ kiện cửa và cửa sổ quốc tế. Mạng lưới đối tác rộng khắp toàn cầu cho phép
                                chúng tôi duy trì mối liên hệ chặt chẽ với các đối tác, nhà thiết kế và nhà đầu tư. Nếu
                                bạn cần bất kỳ sự hỗ trợ nào hoặc có câu hỏi về các phụ kiện tùy chỉnh của chúng tôi,
                                vui lòng liên hệ với chúng tôi – đội ngũ kinh doanh quốc tế của chúng tôi sẽ cố gắng
                                phản hồi bạn trong thời gian sớm nhất.</p>
                        </div>
                    </div>
                </section>
            </div>
            <section class="ContactInfo__ContactInfoWrap-sc-1lfxesj-0 bjVFqt">
                <div class="animated fadeInUp" style="animation-duration: 1s;">
                    <div class="container_small">
                        <div class="contact_section">
                            <h3>Việt Nam Contact</h3>
                            <ul>
                                <li class="email"><a href="mailto:cmechvietnam.com@gmail.com"><svg width="100%"
                                            height="100%" viewBox="0 0 480 337" version="1.1"
                                            xmlns="http://www.w3.org/2000/svg" xml:space="preserve">
                                            <g transform="matrix(1,0,0,1,-8.32667e-17,-71.984)">
                                                <path
                                                    d="M479.848,79.216C479.794,78.673 479.687,78.138 479.528,77.616C479.368,77.099 479.153,76.6 478.888,76.128C478.76,75.904 478.736,75.64 478.584,75.424C478.432,75.208 478.24,75.12 478.088,74.936C477.731,74.515 477.331,74.132 476.896,73.792C476.517,73.488 476.11,73.22 475.68,72.992C475.233,72.762 474.764,72.577 474.28,72.44C473.757,72.285 473.222,72.178 472.68,72.12C472.44,72.12 472.232,71.984 471.984,71.984L8,71.984C7.758,72.02 7.517,72.068 7.28,72.128C6.759,72.18 6.244,72.285 5.744,72.44C5.248,72.581 4.765,72.769 4.304,73C3.883,73.23 3.485,73.498 3.112,73.8C2.672,74.14 2.27,74.526 1.912,74.952C1.76,75.136 1.552,75.24 1.416,75.44C1.28,75.64 1.24,75.92 1.112,76.144C0.847,76.616 0.632,77.115 0.472,77.632C0.313,78.154 0.206,78.689 0.152,79.232C0.152,79.496 0,79.728 0,80.032L0,400.016C0,404.434 3.582,408.016 8,408.016L472,408.016C476.418,408.016 480,404.434 480,400.016L480,80.016C480,79.744 479.872,79.512 479.848,79.216ZM446.304,88.016L240,230.296L33.696,88.016L446.304,88.016ZM464,392.016L16,392.016L16,95.256L235.456,246.6C239.191,247.488 240.809,247.488 244.544,246.6L464,95.256L464,392.016Z">
                                                </path>
                                            </g>
                                        </svg><span>cmechvietnam.com@gmail.com</span></a></li>
                                <li><a href="tel:+84949414368"><svg width="100%" height="100%" viewBox="0 0 513 513"
                                            version="1.1" xmlns="http://www.w3.org/2000/svg" xml:space="preserve">
                                            <g transform="matrix(1,0,0,1,-0.000320502,-0.0179412)">
                                                <g transform="matrix(1,0,0,1,-1,-1)">
                                                    <path
                                                        d="M499.639,396.039L395.993,326.919C382.84,318.218 365.209,321.081 355.485,333.498L325.294,372.316C321.414,377.432 314.361,378.916 308.748,375.798L303.005,372.632C283.967,362.255 260.279,349.336 212.552,301.592C164.825,253.848 151.88,230.142 141.503,211.139L138.354,205.396C135.193,199.784 136.649,192.701 141.767,188.79L180.559,158.608C192.971,148.883 195.838,131.257 187.147,118.1L118.027,14.454C109.12,1.056 91.25,-2.966 77.461,5.323L34.12,31.358C20.502,39.364 10.511,52.33 6.242,67.539C-9.365,124.405 2.376,222.547 146.948,367.136C261.952,482.131 347.567,513.056 406.413,513.056C419.956,513.114 433.446,511.352 446.52,507.817C461.732,503.553 474.7,493.561 482.701,479.939L508.762,436.624C517.063,422.832 513.043,404.951 499.639,396.039ZM494.058,427.868L468.057,471.209C462.312,481.041 452.985,488.27 442.03,491.382C389.533,505.795 297.817,493.857 159.022,355.062C20.227,216.267 8.29,124.559 22.703,72.054C25.819,61.086 33.057,51.747 42.901,45.993L86.242,19.992C92.225,16.392 99.981,18.137 103.846,23.951L141.393,80.322L172.907,127.588C176.681,133.295 175.441,140.944 170.057,145.167L131.256,175.349C119.448,184.378 116.076,200.715 123.346,213.681L126.427,219.279C137.333,239.281 150.892,264.164 200.394,313.658C249.896,363.151 274.771,376.711 294.764,387.616L300.37,390.705C313.335,397.974 329.673,394.603 338.702,382.795L368.884,343.994C373.108,338.613 380.754,337.374 386.463,341.144L490.1,410.264C495.918,414.126 497.663,421.886 494.058,427.868Z">
                                                    </path>
                                                </g>
                                            </g>
                                        </svg><span>0949 414 368</span></a></li>
                            </ul>
                        </div>
                        <div class="contact_section">
                            <h3>Global Contact</h3>
                            <ul>
                                <li class="email"><a href="mailto:wade.dong@cmech.com"><svg width="100%" height="100%"
                                            viewBox="0 0 480 337" version="1.1" xmlns="http://www.w3.org/2000/svg"
                                            xml:space="preserve">
                                            <g transform="matrix(1,0,0,1,-8.32667e-17,-71.984)">
                                                <path
                                                    d="M479.848,79.216C479.794,78.673 479.687,78.138 479.528,77.616C479.368,77.099 479.153,76.6 478.888,76.128C478.76,75.904 478.736,75.64 478.584,75.424C478.432,75.208 478.24,75.12 478.088,74.936C477.731,74.515 477.331,74.132 476.896,73.792C476.517,73.488 476.11,73.22 475.68,72.992C475.233,72.762 474.764,72.577 474.28,72.44C473.757,72.285 473.222,72.178 472.68,72.12C472.44,72.12 472.232,71.984 471.984,71.984L8,71.984C7.758,72.02 7.517,72.068 7.28,72.128C6.759,72.18 6.244,72.285 5.744,72.44C5.248,72.581 4.765,72.769 4.304,73C3.883,73.23 3.485,73.498 3.112,73.8C2.672,74.14 2.27,74.526 1.912,74.952C1.76,75.136 1.552,75.24 1.416,75.44C1.28,75.64 1.24,75.92 1.112,76.144C0.847,76.616 0.632,77.115 0.472,77.632C0.313,78.154 0.206,78.689 0.152,79.232C0.152,79.496 0,79.728 0,80.032L0,400.016C0,404.434 3.582,408.016 8,408.016L472,408.016C476.418,408.016 480,404.434 480,400.016L480,80.016C480,79.744 479.872,79.512 479.848,79.216ZM446.304,88.016L240,230.296L33.696,88.016L446.304,88.016ZM464,392.016L16,392.016L16,95.256L235.456,246.6C239.191,247.488 240.809,247.488 244.544,246.6L464,95.256L464,392.016Z">
                                                </path>
                                            </g>
                                        </svg><span>wade.dong@cmech.com</span></a></li>
                                <li><a href="tel:+86 137 9860 9716"><svg width="100%" height="100%"
                                            viewBox="0 0 513 513" version="1.1" xmlns="http://www.w3.org/2000/svg"
                                            xml:space="preserve">
                                            <g transform="matrix(1,0,0,1,-0.000320502,-0.0179412)">
                                                <g transform="matrix(1,0,0,1,-1,-1)">
                                                    <path
                                                        d="M499.639,396.039L395.993,326.919C382.84,318.218 365.209,321.081 355.485,333.498L325.294,372.316C321.414,377.432 314.361,378.916 308.748,375.798L303.005,372.632C283.967,362.255 260.279,349.336 212.552,301.592C164.825,253.848 151.88,230.142 141.503,211.139L138.354,205.396C135.193,199.784 136.649,192.701 141.767,188.79L180.559,158.608C192.971,148.883 195.838,131.257 187.147,118.1L118.027,14.454C109.12,1.056 91.25,-2.966 77.461,5.323L34.12,31.358C20.502,39.364 10.511,52.33 6.242,67.539C-9.365,124.405 2.376,222.547 146.948,367.136C261.952,482.131 347.567,513.056 406.413,513.056C419.956,513.114 433.446,511.352 446.52,507.817C461.732,503.553 474.7,493.561 482.701,479.939L508.762,436.624C517.063,422.832 513.043,404.951 499.639,396.039ZM494.058,427.868L468.057,471.209C462.312,481.041 452.985,488.27 442.03,491.382C389.533,505.795 297.817,493.857 159.022,355.062C20.227,216.267 8.29,124.559 22.703,72.054C25.819,61.086 33.057,51.747 42.901,45.993L86.242,19.992C92.225,16.392 99.981,18.137 103.846,23.951L141.393,80.322L172.907,127.588C176.681,133.295 175.441,140.944 170.057,145.167L131.256,175.349C119.448,184.378 116.076,200.715 123.346,213.681L126.427,219.279C137.333,239.281 150.892,264.164 200.394,313.658C249.896,363.151 274.771,376.711 294.764,387.616L300.37,390.705C313.335,397.974 329.673,394.603 338.702,382.795L368.884,343.994C373.108,338.613 380.754,337.374 386.463,341.144L490.1,410.264C495.918,414.126 497.663,421.886 494.058,427.868Z">
                                                    </path>
                                                </g>
                                            </g>
                                        </svg><span>+86 137 9860 9716</span></a></li>
                            </ul>
                        </div>
                        <div class="contact_section">
                            <h3>Global Contact</h3>
                            <ul>
                                <li><a href="mailto:maggie.yang@cmech.com"><svg width="100%" height="100%"
                                            viewBox="0 0 480 337" version="1.1" xmlns="http://www.w3.org/2000/svg"
                                            xml:space="preserve">
                                            <g transform="matrix(1,0,0,1,-8.32667e-17,-71.984)">
                                                <path
                                                    d="M479.848,79.216C479.794,78.673 479.687,78.138 479.528,77.616C479.368,77.099 479.153,76.6 478.888,76.128C478.76,75.904 478.736,75.64 478.584,75.424C478.432,75.208 478.24,75.12 478.088,74.936C477.731,74.515 477.331,74.132 476.896,73.792C476.517,73.488 476.11,73.22 475.68,72.992C475.233,72.762 474.764,72.577 474.28,72.44C473.757,72.285 473.222,72.178 472.68,72.12C472.44,72.12 472.232,71.984 471.984,71.984L8,71.984C7.758,72.02 7.517,72.068 7.28,72.128C6.759,72.18 6.244,72.285 5.744,72.44C5.248,72.581 4.765,72.769 4.304,73C3.883,73.23 3.485,73.498 3.112,73.8C2.672,74.14 2.27,74.526 1.912,74.952C1.76,75.136 1.552,75.24 1.416,75.44C1.28,75.64 1.24,75.92 1.112,76.144C0.847,76.616 0.632,77.115 0.472,77.632C0.313,78.154 0.206,78.689 0.152,79.232C0.152,79.496 0,79.728 0,80.032L0,400.016C0,404.434 3.582,408.016 8,408.016L472,408.016C476.418,408.016 480,404.434 480,400.016L480,80.016C480,79.744 479.872,79.512 479.848,79.216ZM446.304,88.016L240,230.296L33.696,88.016L446.304,88.016ZM464,392.016L16,392.016L16,95.256L235.456,246.6C239.191,247.488 240.809,247.488 244.544,246.6L464,95.256L464,392.016Z">
                                                </path>
                                            </g>
                                        </svg><span>maggie.yang@cmech.com</span></a></li>
                                <li><a href="tel:+86 137 0274 8585"><svg width="100%" height="100%"
                                            viewBox="0 0 513 513" version="1.1" xmlns="http://www.w3.org/2000/svg"
                                            xml:space="preserve">
                                            <g transform="matrix(1,0,0,1,-0.000320502,-0.0179412)">
                                                <g transform="matrix(1,0,0,1,-1,-1)">
                                                    <path
                                                        d="M499.639,396.039L395.993,326.919C382.84,318.218 365.209,321.081 355.485,333.498L325.294,372.316C321.414,377.432 314.361,378.916 308.748,375.798L303.005,372.632C283.967,362.255 260.279,349.336 212.552,301.592C164.825,253.848 151.88,230.142 141.503,211.139L138.354,205.396C135.193,199.784 136.649,192.701 141.767,188.79L180.559,158.608C192.971,148.883 195.838,131.257 187.147,118.1L118.027,14.454C109.12,1.056 91.25,-2.966 77.461,5.323L34.12,31.358C20.502,39.364 10.511,52.33 6.242,67.539C-9.365,124.405 2.376,222.547 146.948,367.136C261.952,482.131 347.567,513.056 406.413,513.056C419.956,513.114 433.446,511.352 446.52,507.817C461.732,503.553 474.7,493.561 482.701,479.939L508.762,436.624C517.063,422.832 513.043,404.951 499.639,396.039ZM494.058,427.868L468.057,471.209C462.312,481.041 452.985,488.27 442.03,491.382C389.533,505.795 297.817,493.857 159.022,355.062C20.227,216.267 8.29,124.559 22.703,72.054C25.819,61.086 33.057,51.747 42.901,45.993L86.242,19.992C92.225,16.392 99.981,18.137 103.846,23.951L141.393,80.322L172.907,127.588C176.681,133.295 175.441,140.944 170.057,145.167L131.256,175.349C119.448,184.378 116.076,200.715 123.346,213.681L126.427,219.279C137.333,239.281 150.892,264.164 200.394,313.658C249.896,363.151 274.771,376.711 294.764,387.616L300.37,390.705C313.335,397.974 329.673,394.603 338.702,382.795L368.884,343.994C373.108,338.613 380.754,337.374 386.463,341.144L490.1,410.264C495.918,414.126 497.663,421.886 494.058,427.868Z">
                                                    </path>
                                                </g>
                                            </g>
                                        </svg><span>+86 137 0274 8585</span></a></li>
                            </ul>
                        </div>
                        <div class="contact_section">
                            <h3>India Contact</h3>
                            <ul>
                                <li><a href="mailto:kamath.shreyas.subhas@cmech.com"><svg width="100%" height="100%"
                                            viewBox="0 0 480 337" version="1.1" xmlns="http://www.w3.org/2000/svg"
                                            xml:space="preserve">
                                            <g transform="matrix(1,0,0,1,-8.32667e-17,-71.984)">
                                                <path
                                                    d="M479.848,79.216C479.794,78.673 479.687,78.138 479.528,77.616C479.368,77.099 479.153,76.6 478.888,76.128C478.76,75.904 478.736,75.64 478.584,75.424C478.432,75.208 478.24,75.12 478.088,74.936C477.731,74.515 477.331,74.132 476.896,73.792C476.517,73.488 476.11,73.22 475.68,72.992C475.233,72.762 474.764,72.577 474.28,72.44C473.757,72.285 473.222,72.178 472.68,72.12C472.44,72.12 472.232,71.984 471.984,71.984L8,71.984C7.758,72.02 7.517,72.068 7.28,72.128C6.759,72.18 6.244,72.285 5.744,72.44C5.248,72.581 4.765,72.769 4.304,73C3.883,73.23 3.485,73.498 3.112,73.8C2.672,74.14 2.27,74.526 1.912,74.952C1.76,75.136 1.552,75.24 1.416,75.44C1.28,75.64 1.24,75.92 1.112,76.144C0.847,76.616 0.632,77.115 0.472,77.632C0.313,78.154 0.206,78.689 0.152,79.232C0.152,79.496 0,79.728 0,80.032L0,400.016C0,404.434 3.582,408.016 8,408.016L472,408.016C476.418,408.016 480,404.434 480,400.016L480,80.016C480,79.744 479.872,79.512 479.848,79.216ZM446.304,88.016L240,230.296L33.696,88.016L446.304,88.016ZM464,392.016L16,392.016L16,95.256L235.456,246.6C239.191,247.488 240.809,247.488 244.544,246.6L464,95.256L464,392.016Z">
                                                </path>
                                            </g>
                                        </svg><span>kamath.shreyas.subhas@cmech.com</span></a></li>
                                <li><a href="tel:+91 9686 5943 97 "><svg width="100%" height="100%"
                                            viewBox="0 0 513 513" version="1.1" xmlns="http://www.w3.org/2000/svg"
                                            xml:space="preserve">
                                            <g transform="matrix(1,0,0,1,-0.000320502,-0.0179412)">
                                                <g transform="matrix(1,0,0,1,-1,-1)">
                                                    <path
                                                        d="M499.639,396.039L395.993,326.919C382.84,318.218 365.209,321.081 355.485,333.498L325.294,372.316C321.414,377.432 314.361,378.916 308.748,375.798L303.005,372.632C283.967,362.255 260.279,349.336 212.552,301.592C164.825,253.848 151.88,230.142 141.503,211.139L138.354,205.396C135.193,199.784 136.649,192.701 141.767,188.79L180.559,158.608C192.971,148.883 195.838,131.257 187.147,118.1L118.027,14.454C109.12,1.056 91.25,-2.966 77.461,5.323L34.12,31.358C20.502,39.364 10.511,52.33 6.242,67.539C-9.365,124.405 2.376,222.547 146.948,367.136C261.952,482.131 347.567,513.056 406.413,513.056C419.956,513.114 433.446,511.352 446.52,507.817C461.732,503.553 474.7,493.561 482.701,479.939L508.762,436.624C517.063,422.832 513.043,404.951 499.639,396.039ZM494.058,427.868L468.057,471.209C462.312,481.041 452.985,488.27 442.03,491.382C389.533,505.795 297.817,493.857 159.022,355.062C20.227,216.267 8.29,124.559 22.703,72.054C25.819,61.086 33.057,51.747 42.901,45.993L86.242,19.992C92.225,16.392 99.981,18.137 103.846,23.951L141.393,80.322L172.907,127.588C176.681,133.295 175.441,140.944 170.057,145.167L131.256,175.349C119.448,184.378 116.076,200.715 123.346,213.681L126.427,219.279C137.333,239.281 150.892,264.164 200.394,313.658C249.896,363.151 274.771,376.711 294.764,387.616L300.37,390.705C313.335,397.974 329.673,394.603 338.702,382.795L368.884,343.994C373.108,338.613 380.754,337.374 386.463,341.144L490.1,410.264C495.918,414.126 497.663,421.886 494.058,427.868Z">
                                                    </path>
                                                </g>
                                            </g>
                                        </svg><span>+91 9686 5943 97 </span></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            <div>

                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3918.301741805047!2d106.65477347504309!3d10.864638889289557!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTDCsDUxJzUyLjciTiAxMDbCsDM5JzI2LjUiRQ!5e0!3m2!1svi!2s!4v1734890944766!5m2!1svi!2s"
                    width="100%" height="400" style="border:0;" allowfullscreen="" loading="lazy"
                    referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>
        </div>




















    </PublicTemplate>
</template>

<script>
import PublicTemplate from '@/templates/PublicTemplate.vue';
export default {
    name: 'CompanyView',
    components: {
        PublicTemplate
    },
    mounted() {
        window.scrollTo(0, 0);
    }
}
</script>


<style lang="less">
.jsJJkA .contact_form {
    margin-bottom: 80px;
}

/*!sc*/
@media (max-width:768px) {
    .jsJJkA .contact_form {
        margin-bottom: 10px;
    }
}

/*!sc*/
.jsJJkA .contact_form .container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
}

/*!sc*/
@media (max-width:1024px) {
    .jsJJkA .contact_form .container {
        display: block;
        padding: 0;
    }
}

/*!sc*/
.jsJJkA .contact_form .container .left_side {
    background-color: #f7f5f4;
    padding: 30px;
    padding-top: 60px;
}

/*!sc*/
@media (max-width:1024px) {
    .jsJJkA .contact_form .container .left_side {
        margin-bottom: 30px;
        padding: 15px;
        padding-top: 60px;
        padding-bottom: 60px;
    }
}

/*!sc*/
.jsJJkA .contact_form .container .left_side img {
    display: block;
    width: 100%;
    margin-bottom: 100px;
}

/*!sc*/
@media (max-width:1024px) {
    .jsJJkA .contact_form .container .left_side img {
        margin-bottom: 40px;
    }
}

/*!sc*/
.jsJJkA .contact_form .container .left_side p {
    font-size: 0.8em;
    text-align: center;
    font-weight: 300;
}

/*!sc*/
.jsJJkA .contact_form .container form {
    background-color: #f7f5f4;
    padding: 30px;
    padding-top: 60px;
}

/*!sc*/
@media (max-width:480px) {
    .jsJJkA .contact_form .container form {
        width: 100%;
        padding: 40px 15px;
    }
}

/*!sc*/
.jsJJkA .contact_form .container form fieldset {
    border: 0;
    padding: 0;
}

/*!sc*/
.jsJJkA .contact_form .container form fieldset label {
    display: block;
    margin-bottom: 15px;
    font-size: 0.6em;
    font-weight: 300;
}

/*!sc*/
@media (max-width:1024px) {
    .jsJJkA .contact_form .container form fieldset label {
        font-size: 0.8em;
    }
}

/*!sc*/
.jsJJkA .contact_form .container form fieldset label:last-of-type {
    margin-bottom: 40px;
}

/*!sc*/
.jsJJkA .contact_form .container form fieldset label input {
    display: block;
    background-color: white;
    border: 0;
    outline: 0;
    border-radius: 6px;
    padding: 16px;
    width: 100%;
}

/*!sc*/
.jsJJkA .contact_form .container form fieldset textarea {
    display: block;
    height: 250px;
    box-sizing: border-box;
    margin: 0 auto;
    resize: none;
    background-color: white;
    border: 0;
    outline: 0;
    border-radius: 6px;
    margin-bottom: 25px;
    padding: 25px 15px;
    width: 100%;
    font-weight: 300;
    font-size: 0.6em;
}

/*!sc*/
@media (max-width:480px) {
    .jsJJkA .contact_form .container form fieldset textarea {
        height: 190px;
        font-size: 0.8em;
    }
}

/*!sc*/
.jsJJkA .contact_form .container form fieldset button {
    display: block;
    width: 100%;
    margin: 0 auto;
    background-color: var(--brand_black);
    text-align: center;
    border-radius: 6px;
    color: white;
    padding: 15px 20px;
    font-size: 0.6em;
    font-weight: 400;
    text-transform: uppercase;
}

/*!sc*/
.jsJJkA .contact_form .container form fieldset .submit_state {
    text-align: center;
    font-weight: 500;
    font-size: 20px;
    padding: 12px 0;
}

/*!sc*/
.jsJJkA .contact_form .container form fieldset .submit_state.error {
    color: red;
}

/*!sc*/
.jsJJkA .contact_form .container form fieldset .submit_state.success {
    color: green;
}

/*!sc*/
data-styled.g85[id="contact__ContactPage-sc-6y2oza-0"] {
    content: "jsJJkA,"
}

/*!sc*/


.bjVFqt {
    display: block;
    background-color: black;
    color: white;
}

/*!sc*/
.bjVFqt .container_small {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 40px;
    padding: 105px 0 85px 0;
    text-align: center;
}

/*!sc*/
@media (max-width:1024px) {
    .bjVFqt .container_small {
        grid-template-columns: repeat(2, 1fr);
        padding: 60px 0 60px 0;
    }
}

/*!sc*/
@media (max-width:480px) {
    .bjVFqt .container_small {
        grid-template-columns: 1fr;
    }
}

/*!sc*/
.bjVFqt .container_small .contact_section h3 {
    font-size: 0.7em;
    font-weight: 300;
    margin-bottom: 43px;
    -webkit-letter-spacing: 1.5px;
    -moz-letter-spacing: 1.5px;
    -ms-letter-spacing: 1.5px;
    letter-spacing: 1.5px;
}

/*!sc*/
@media (max-width:1024px) {
    .bjVFqt .container_small .contact_section h3 {
        margin-bottom: 25px;
        font-size: 0.8em;
    }
}

/*!sc*/
.bjVFqt .container_small .contact_section ul {
    display: inline-block;
}

/*!sc*/
.bjVFqt .container_small .contact_section ul li {
    list-style-type: none;
    margin-bottom: 20px;
    text-align: center;
}

/*!sc*/
.bjVFqt .container_small .contact_section ul li:nth-of-type(2) a svg {
    height: 20px;
}

/*!sc*/
.bjVFqt .container_small .contact_section ul li a {
    color: white;
    font-weight: 400;
    -webkit-text-decoration: none;
    text-decoration: none;
    color: #f7f7f7;
    -webkit-letter-spacing: 1.5px;
    -moz-letter-spacing: 1.5px;
    -ms-letter-spacing: 1.5px;
    letter-spacing: 1.5px;
    display: grid;
    grid-template-columns: 30px 1fr;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    gap: 20px;
    font-size: 0.6em;
}

/*!sc*/
@media (max-width:1024px) {
    .bjVFqt .container_small .contact_section ul li a {
        font-size: 0.7em;
    }
}

/*!sc*/
.bjVFqt .container_small .contact_section ul li a span {
    text-align: left;
}

/*!sc*/
.bjVFqt .container_small .contact_section ul li a svg {
    fill: white;
    display: inline-block;
    height: 17px;
    width: 30px;
}

/*!sc*/
.bjVFqt .container_small .contact_section ul .email a svg {
    height: 17px !important;
}

/*!sc*/
data-styled.g47[id="ContactInfo__ContactInfoWrap-sc-1lfxesj-0"] {
    content: "bjVFqt,"
}

/*!sc*/
</style>